(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop001-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const button=event.target.closest('[data-twoz-collection] [data-filter]');
  if(!button)return;
  const section=button.closest('[data-twoz-collection]');
  section.querySelectorAll('[data-filter]').forEach(item=>{
    const active=item===button;
    item.classList.toggle('is-active',active);
    item.setAttribute('aria-pressed',String(active));
  });
  section.querySelectorAll('.twoz-collection__card').forEach(card=>{
    card.hidden=button.dataset.filter!=='all'&&card.dataset.type!==button.dataset.filter;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop001-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('twoz-preview-gallery')) {
    customElements.define('twoz-preview-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const track = this.querySelector('[data-gallery-track]');
        const dots = [...this.querySelectorAll('[data-gallery-index]')];
        if (!track || !dots.length) return;
        const sync = () => {
          const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === index);
            dot.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        };
        track.addEventListener('scroll', sync, { ...options, passive: true });
        window.addEventListener('resize', sync, options);
        dots.forEach(dot => dot.addEventListener('click', () => {
          track.scrollTo({
            left: Number(dot.dataset.galleryIndex) * track.clientWidth,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }, options));
        sync();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
